import React from 'react';
import { useTranslation } from 'react-i18next';
import { Alert } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import styles from './client-blocked-alert.module.scss';
import type { IClientBlockedAlertProps } from './types.ts';

export const ClientBlockedAlert: React.FC<IClientBlockedAlertProps> = (props) => {
  const { isBlocked } = props;
  const { t } = useTranslation();

  if (!isBlocked) return null;

  return (
    <Alert
      className={styles.alert}
      icon={<LockOutlined className={styles.status} />}
      message={
        <span className={styles.status}>
          <strong>{t('client:blocked_client_banner')}</strong> {t('client:blocked_client_orders_disabled')}
        </span>
      }
      type='error'
      showIcon
    />
  );
};
